'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _url = require('../../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formValues) {
  var applicants = formValues.applicants,
      additional_data = formValues.application.additional_data;


  additional_data.basic_life_flat_benefit_amount = additional_data.basic_life_flat_benefit_amount ? additional_data.basic_life_flat_benefit_amount.replace(/\$/g, '').replace(/,/g, '') : additional_data.basic_life_flat_benefit_amount;
  additional_data.adnd_insurance_flat_benefit_amount = additional_data.adnd_insurance_flat_benefit_amount ? additional_data.adnd_insurance_flat_benefit_amount.replace(/\$/g, '').replace(/,/g, '') : additional_data.adnd_insurance_flat_benefit_amount;

  applicants.forEach(function (applicant, index) {
    applicant.additional_data.salary = applicant.additional_data.salary ? applicant.additional_data.salary.replace(/\$/g, '').replace(/,/g, '') : applicant.additional_data.salary;
    applicant.additional_data.policy_type = formValues.application.additional_data.form_type === 'group' && formValues.application.additional_data.dependent_medical_coverage === '0' ? 'single' : applicant.additional_data.policy_type;
  });

  return {
    email: formValues.application.email,
    additional_data: _extends({}, additional_data, {
      tracking_code: (0, _url2.default)('tracking_code', null),
      applicant_count: formValues.application.additional_data.applicant_count,
      expiry_date: formValues.application.additional_data.expiry_date || (0, _moment2.default)(formValues.application.additional_data.effective_date).add(365, 'days').format('YYYY-MM-DD'),
      dependent_medical_coverage: formValues.application.additional_data.form_type === 'group' ? formValues.application.additional_data.dependent_medical_coverage || '1' : null
    })
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/msh/global2go/application.js
// module id = 821
// module chunks = 0